import { useReactiveFeatureFlagValue } from '@/app/contexts';
import {
  MEDIA_PLAYER_TRANSITION_FLAG_CAMEL,
  MEDIA_PLAYER_TRANSITION_FLAG_KEY,
  isJsonMediaEnabled,
  isMediaPlayerTransitionEnabled,
  parseMediaPlayerTransition,
  type MediaPlayerTransitionFlag,
  type MediaPlayerTransitionViewer,
} from '@/shared/media-player-transition';

export function useMediaPlayerTransitionFlagValue(): unknown {
  const camel = useReactiveFeatureFlagValue(MEDIA_PLAYER_TRANSITION_FLAG_CAMEL);
  const kebab = useReactiveFeatureFlagValue(MEDIA_PLAYER_TRANSITION_FLAG_KEY);
  return camel ?? kebab;
}

export function useMediaPlayerTransition(): MediaPlayerTransitionFlag {
  return parseMediaPlayerTransition(useMediaPlayerTransitionFlagValue());
}

export function useMediaPlayerTransitionEnabled(viewer: MediaPlayerTransitionViewer): boolean {
  return isMediaPlayerTransitionEnabled(useMediaPlayerTransitionFlagValue(), viewer);
}

/** Theme JSON viewer + JSON-as-displayable-type. See ``isJsonMediaEnabled``. */
export function useJsonMediaDisplayEnabled(): boolean {
  const legacy = useReactiveFeatureFlagValue('jsonMediaDisplay');
  const transition = useMediaPlayerTransitionFlagValue();
  return isJsonMediaEnabled({
    jsonMediaDisplay: legacy,
    [MEDIA_PLAYER_TRANSITION_FLAG_CAMEL]: transition,
  });
}
